import { combineReducers } from 'redux';

import view from './reducers/view';

const reducers = combineReducers({
  view,
});

export default reducers;
